<div class="alert alert-warning" role="alert" style="margin: 0 0 15px; text-align: center; font-weight: 500;">
  This page will be retired soon. Chart Favorites can be created and accessed from the Analyze Sensor Readings page.
</div>
<hr style="margin-top: 0px; margin-bottom: 15px;">
<div class="container-fluid">
  <div *ngIf="readySensorGroups && chartFavoritesLoaded && isReadyAssociatedUserGroups; else loading">
    <p-confirmDialog key="cd1" #cd1>
      <ng-template #footer>
          <button type="button" class="btn btn-success" (click)="cd1.onAccept()">Continue</button>
          <button type="button" class="btn btn-basic" (click)="cd1.onReject()">Cancel</button>
      </ng-template>
    </p-confirmDialog>

    <div *ngIf="readySensorGroups" style="display: flex; gap: 10px;">

      <div style="min-width: 365px; max-width: 365px; border-right: 1px solid lightgray; padding-right: 15px;">
        <label style="margin-bottom: 10px; font-size: 17px; font-weight: 500">LOAD</label>

        <div class="form-group" style="margin-bottom: 5px;">
          <label style="margin-bottom: 1px;">Chart Favorites</label> 
          <ng-select [items]=chartFavoritesNamesToDisplay
              bindLabel="name"
              (change) = "favoriteSelectionChanged($event)"
              placeholder = "Select Favorite"
              [(ngModel)]="selectedChartFavorite"
              (focus)="updateChartFavoritesList(global.globalSwitch)"
              groupBy="toGroupBy"
              >
          </ng-select>
        </div>

        <div style="display: flex; gap: 15px; margin-bottom: 25px;">
          <button type="button" class="btn btn-success" (click)="saveChartFavorite(template)" [disabled]="!isChartFavoriteReadyToSave()">Save</button>
          <button type="button" class="btn btn-danger" (click)="onDeleteChartFavoriteConfirm()" [disabled]="selectedChartFavorite == undefined || (selectedChartFavorite != undefined && !selectedChartFavorite.userFeatureAccess['DeleteChart'])">Delete</button>
          <label *ngIf="selectedChartFavorite != undefined" style="margin-top: 6px;">id={{ selectedChartFavorite.id }}</label>
        </div>

        <label style="margin-bottom: 10px; font-size: 17px; font-weight: 500">BUILD</label>

        <div class="form-group" style="margin-bottom: 13px;">
          <label style="margin-bottom: 1px;">Sensor Groups</label> 
          <ng-select [items]="sensorGroups"
                    bindLabel="name"
                    autofocus
                    (change) = "sensorGroupSelectionChanged($event)"
                    placeholder = "Select Sensor Group"
                    [(ngModel)]="selectedSensorGroup"
                    style="height: 38px;">
          </ng-select>
        </div>

        <div class="form-group" style="margin-bottom: 13px;">
          <label style="margin-bottom: 1px;">Sensors</label> 
          <ng-multiselect-dropdown
                    [placeholder]="'Select Sensors'"
                    [settings]="sensorDropDownSettings"
                    autofocus
                    [data]="sensorsDetails"
                    [(ngModel)]="selectedSensors"
                    (onSelect)="sensorSelectionChanged($event)"
                    (onSelectAll)="sensorSelectAllSelectionChanged($event)"
                    (onDeSelect)="sensorDeSelectionChanged($event)"
                    (onDeSelectAll)="sensorDeSelectAllSelectionChanged($event)">
          </ng-multiselect-dropdown>
        </div>

        <div class="form-group" style="margin-bottom: 13px;">
          <label style="margin-bottom: 1px;">Reading Types</label> 
          <ng-multiselect-dropdown
                    [placeholder]="'Select Reading Types'"
                    [settings]="datatypeDropDownSettings"
                    [data]="sensorReadingTypeDetails"
                    [(ngModel)]="selectedDataTypes"
                    (onSelect)="datatypeSelectionChanged($event)"
                    (onSelectAll)="datatypeSelectAllSelectionChanged($event)"
                    (onDeSelect)="datatypeDeSelectionChanged($event)"
                    (onDeSelectAll)="datatypeDeSelectAllSelectionChanged($event)">
          </ng-multiselect-dropdown>
        </div>

        <div style="display: flex; gap: 15px;">
          <div class="form-group" style="margin-bottom: 13px; width: 75%;">
            <label style="margin-bottom: 1px;" for="daterange">Date Range</label> 
            <input type="text" name="daterange" id="daterange" class="daterangeinput" style="height: 38px;" autocomplete="off"
                      ngxDaterangepickerMd
                      [(ngModel)]="selectedDateRange"
                      [showCustomRangeLabel]="true"
                      [alwaysShowCalendars]="true"
                      [ranges]="ranges"
                      [showRangeLabelOnInput]="true"
                      [linkedCalendars]="true"
                      [isInvalidDate] = "isInvalidDate"
                      [showClearButton]="true"
                      (datesUpdated)="datesUpdated($event)"
                      placeholder="Select Date Range"
                      (rangeClicked)="setRangeSelected($event)"/>
          </div>
          <div class="form-group" style="margin-bottom: 13px; width: 25%;">
            <label style="margin-bottom: 1px;" for="datacount" class="css-tooltip" [attr.tooltip-data]="sensorReadingCountMsg">#Readings</label> 
            <input *ngIf="sensorReadingCount <= maxChartReadingCount" type="text" name="datacount" id="datacount" style="height: 38px; width: 100%;" disabled="true" [(ngModel)]="sensorReadingCount">
            <input *ngIf="sensorReadingCount > maxChartReadingCount" type="text" name="datacount" id="datacount" style="height: 38px; width: 100%; color: red;" disabled="true" [(ngModel)]="sensorReadingCount">
            <span *ngIf="reloadSensorReadings && !sensorReadingCountReady" class="fa fa-spinner fa-spin fa-1x fa-fw" style="margin-left: -40px;"></span>
          </div>
        </div>

        <div class="form-group" style="margin-bottom: 10px;">
          <label for="TimeZone" style="font-weight: 500; font-size: 15px;">Displayed Timezone</label>
          <div style="font-size: 14px; margin-top: 2px; margin-bottom: 10px;">
              <input type="radio" [(ngModel)]="selectedTimeZone" name="Local" value="Local" (ngModelChange)="selectedTimeZoneChanged()" style="cursor: pointer;"/>
              <label style="padding-left: 5px; padding-right: 20px;">Local</label>
              <input type="radio" [(ngModel)]="selectedTimeZone" name="Source" value="Source" (ngModelChange)="selectedTimeZoneChanged()" style="cursor: pointer;"/>
              <label style="padding-left: 5px; padding-right: 20px;">Source</label>
              <input type="radio" [(ngModel)]="selectedTimeZone" name="UTC" value="UTC" (ngModelChange)="selectedTimeZoneChanged()" style="cursor: pointer;"/>
              <label style="padding-left: 5px; padding-right: 20px;">UTC (GMT+0)</label>
          </div>
        </div>

        <div class="form-group" style="margin-bottom: 20px;">
          <label for="readings" style="font-weight: 500; font-size: 15px;">Readings</label>
          <div style="font-size: 14px; margin-top: 2px; margin-bottom: 10px;">
              <input type="checkbox" [(ngModel)]="showOriginalReadings" name="Original" value="showOriginalReadings" (ngModelChange)="selectedReadingSourceChanged()" style="cursor: pointer;"/>
              <label style="padding-left: 5px; padding-right: 25px;;">Original Values</label>
              <input type="checkbox" [(ngModel)]="showCalibratedReadings" name="Calibrated" value="showCalibratedReadings" (ngModelChange)="selectedReadingSourceChanged()" style="cursor: pointer;"/>
              <label style="padding-left: 5px; padding-right: 25px;">Calibrated Values</label>
          </div>
        </div>
    
        <div style="display: flex; gap: 15px;">
          <button *ngIf="reloadSensorReadings" (click)="updateChartData()" class="btn btn-primary" type="button" [disabled]="!enableChartAndExportButtons" style="width: 50%; border: 2px solid yellow;" >Chart</button>
          <button *ngIf="!reloadSensorReadings" (click)="updateChartData()" class="btn btn-primary" type="button" [disabled]="!enableChartAndExportButtons" style="width: 50%;" >Chart</button>
          <button (click)="exportData(exportOptionsTemplate)" type="button" class="btn btn-primary" [disabled]="!enableChartAndExportButtons" style="width: 200px;">Export Readings</button>
        </div>

        <div *ngIf="chartData.length>0" style="display: flex; gap: 15px; margin-top: 15px;">
          <button (click)="overlayEventActionsOnChart()" class="btn btn-primary" type="button" style="width: 50%;" >Overlay Event Actions</button>
          <button (click)="loadSensorReadings()" class="btn btn-primary" type="button" style="width: 200px;" >Reload Readings</button>
        </div>

        <div *ngIf="chartData.length>0" style="display: flex; align-items: center; gap: 8px; margin-top: 15px;">
          <p-toggleswitch [(ngModel)]="echartDarkBackground" name="EchartDarkBackground" [ngModelOptions]="{standalone: true}" (ngModelChange)="onEchartDarkBackgroundChange()"></p-toggleswitch>
          <label style="font-weight: 500; font-size: 15px; margin-left: 25px;">Chart Dark Mode</label>
        </div>
      </div>

      <div *ngIf="chartData.length>0" style="flex: 1 1 auto; min-width: 0; display: flex; flex-direction: column; height: 100%;">
        <chart-readings-echart-modal
            #echartRef
            style="flex: 1 1 auto; min-height: 0;"
            [sensors]="selectedSensors"
            [sensorReadings]="sensorReadingInfos"
            [sensorReadingTypes]="selectedDataTypes"
            [sensorGroups]="echartSensorGroups"
            [dateRangeStart]="echartDateRangeStart"
            [includeCalValues]="showCalibratedReadings"
            [includeOrigValues]="showOriginalReadings"
            [darkBackground]="echartDarkBackground"
            [overlaySeries]="eventOverlaySeries"
            [showYAxisSlider]="true"
            [savedChartDetails]="savedChartDetails"
            (chartDetailsChanged)="onEchartOptionsChanged()"
            [chartHeight]="'calc(100vh - 220px)'">
        </chart-readings-echart-modal>

        <div *ngIf="chartOverlayLoaded; else loadingSmall"></div>
      </div>
    </div>
  </div>
</div>

<ng-template #loading>
  <i class="fa fa-spinner fa-spin fa-2x fa-fw"></i>
  <span>Loading...</span>
</ng-template>

<ng-template #loadingSmall>
  <i class="fa fa-spinner fa-spin fa-1x fa-fw"></i>
  <span>Loading...</span>
</ng-template>

<ng-template #template>
  <div cdkDrag [cdkDragDisabled]="!modalDragOn" cdkDragRootElement=".modal-content">
    <!-- <div class="modal-content"> -->
      <div style="background-color: #548235;  height: 7px;"></div>
      <div class="modal-header" (mouseenter)="setDragOn(true)" (mouseleave)="setDragOn(false)" draggable style="background-color:#a9d18e; height: 50px; padding-top: 20px; border-radius: 0px;">
          <h5 class="modal-title pull-left" style="color: rgb(10, 10, 10); text-transform: none;">Chart Favorite</h5>
      </div>
      <div class="modal-body">
          <div class="container-fluid">
              <div class="col-md-12">
                  <form (ngSubmit)="addOrUpdateChartFavorite()" #favoriteNameEditor="ngForm">
                    <div class="form-group" style="margin-bottom: 20px;">
                        <label for="favoriteName">Favorite Name for Chart Settings*</label>
                        <input type="text" id="favoriteName" name="favoriteName" class="form-control" [(ngModel)]="favoriteName" required />
                    </div>

                    <div class="form-group" style="margin-bottom: 20px;">
                      <label for="ChartFavorite">Access Group*</label>
                      <ngx-select-dropdown [(ngModel)]="selectedUserGroup" [config]="userGroupconfig"
                        [options]="associatedUserGroups" name="ChartFavorite"></ngx-select-dropdown>
                    </div>

                    <div class="far fa-comment pull-right" style="color:#5279bc; cursor: pointer; font-size: 20px; margin-left: 20px; margin-top: 8px; margin-bottom: 25px;" aria-hidden="true" (click)="addNotes2ChangeLog()"></div>
                    <button *ngIf = !isUpdate() type="submit" class="btn btn-success col-xs-5 pull-right">Create</button>
                    <button *ngIf = isUpdate()  type="submit" class="btn btn-success col-xs-5 pull-right">Update</button>
                    <button type="button" class="btn btn-basic col-xs-5 pull-right" (click)="onFavoriteCancelButton($event)">Cancel</button>
                  </form>
              </div>
          </div>
      </div>
    <!-- </div> -->
  </div>
</ng-template>


<ng-template #exportOptionsTemplate>
  <div cdkDrag [cdkDragDisabled]="!modalDragOn" cdkDragRootElement=".modal-content">
  <!-- <div class="modal-content std500px-modal"> -->
      <div style="background-color: #548235;  height: 7px;"></div>
      <div class="modal-header" (mouseenter)="setDragOn(true)" (mouseleave)="setDragOn(false)" style="background-color:#a9d18e; height: 50px; padding-top: 20px; border-radius: 0px;">
        <h5 style="color: rgb(10, 10, 10); text-transform: none;">Export Options</h5>
        <button
          (click)="exportOptionsModalRef.hide()"
          class="ms-auto fas fa-times"pe="button"
          style="background-color: transparent; border: transparent; font-size: 16px; margin-top: -4px;">
        </button>
      </div>
      <div class=" modal-body" [ngStyle]="{'background-color':'white'}">
        <div style="margin-bottom: 20px; display: flex; gap: 20px;">
          <div class="form-group" style="width: 500px;">
              <label for="exportFilename">Filename</label>
              <input type="text" id="exportFilename" name="exportFilename" class="form-control" [(ngModel)]="exportDataCriteria.filename" style="height: 35px;" required>
          </div>
        </div>
        <div style="margin-bottom: 10px; display: flex; gap: 12px;">
          <label style="margin-right: 10px;" for="saveAs">Save As:</label>
          <!-- <input type="radio" [(ngModel)]="exportDataCriteria.saveAs" name="saveAs" value="CSV" style="margin-top: 5px;" />
          <label style="margin-right: 10px;">CSV (Format A)</label> -->
          <input type="radio" [(ngModel)]="exportDataCriteria.saveAs" name="saveAs" value="CSV2" style="margin-top: 5px;" />
          <label style="margin-right: 10px;">CSV</label>
          <input type="radio" [(ngModel)]="exportDataCriteria.saveAs" name="saveAs" value="JSON" style="margin-top: 5px;" />
          <label style="margin-right: 10px;">JSON</label>
        </div>

        <hr>
        <label style="margin-bottom: 15px;">Options </label>

        <div style="margin-bottom: 15px; display: flex; gap: 12px;">
          <input type="radio" [(ngModel)]="exportDataCriteria.interpolateData" name="interpolateData" [value]=false style="margin-top: 5px;" />
          <label>Use original time stamped data (no interpolation)</label>
        </div>

        <div style="margin-bottom: 10px; display: flex; gap: 12px;">
          <input type="radio" [(ngModel)]="exportDataCriteria.interpolateData" name="interpolateData" [value]=true style="margin-top: 5px;" />
          <label>Interpolate data before exporting</label>
        </div>

        <div style="margin-bottom: 10px; margin-left: 26px; display: flex; gap: 12px;">
          <label for="interval">Interval:</label>
          <input type="radio" [(ngModel)]="exportDataCriteria.interpolateInterval" name="interpolateInterval" value="15 Min" style="margin-top: 5px;" (click)="setInterpolateData(true)" />
          <label style="margin-right: 10px;">15 Min</label>
          <input type="radio" [(ngModel)]="exportDataCriteria.interpolateInterval" name="interpolateInterval" value="30 Min" style="margin-top: 5px;" (click)="setInterpolateData(true)" />
          <label style="margin-right: 10px;">30 Min</label>
          <input type="radio" [(ngModel)]="exportDataCriteria.interpolateInterval" name="interpolateInterval" value="1 Hr" style="margin-top: 5px;" (click)="setInterpolateData(true)" />
          <label style="margin-right: 10px;">1 Hr</label>          
          <input type="radio" [(ngModel)]="exportDataCriteria.interpolateInterval" name="interpolateInterval" value="24 Hrs" style="margin-top: 5px;" (click)="setInterpolateData(true)" />
          <label style="margin-right: 10px;">24 Hrs</label>
        </div>

        <div style="margin-bottom: 20px; margin-left: 26px; display: flex; gap: 12px;">
          <label for="interval">Method:</label>
          <input type="radio" [(ngModel)]="exportDataCriteria.interpolateMethod" name="interpolateMethod" value="Linear" style="margin-top: 5px;" (click)="setInterpolateData(true)" />
          <label style="margin-right: 10px;">Linear</label>
          <input type="radio" [(ngModel)]="exportDataCriteria.interpolateMethod" name="interpolateMethod" value="Spline" style="margin-top: 5px;" disabled=true (click)="setInterpolateData(true)" />
          <label style="margin-right: 10px;">Spline</label>
        </div>

        <div style="margin-bottom: 10px; display: flex; gap: 12px;">
          <input type="checkbox" style="vertical-align: middle;" [(ngModel)]="exportDataCriteria.ignoreOutliers" [ngModelOptions]="{standalone: true}" [checked]="exportDataCriteria.ignoreOutliers" style="margin-top: 5px;" />
          <label>Ignore outlier data</label>
        </div>

        <div style="margin-bottom: 10px; margin-left: 26px; display: flex; gap: 12px;">
          <label>Less than</label>
          <input type="text" style="vertical-align: middle;" [(ngModel)]="exportDataCriteria.ignoreOutliersLessThan" [ngModelOptions]="{standalone: true}"/>
        </div>

        <div style="margin-bottom: 10px; margin-left: 26px; display: flex; gap: 12px;">
          <label>or greater than</label>
          <input type="text" style="vertical-align: middle;" [(ngModel)]="exportDataCriteria.ignoreOutliersGreaterThan" [ngModelOptions]="{standalone: true}"/>
        </div>

        <div style="margin-bottom: 20px; display: flex; gap: 12px;">
          <input type="checkbox" style="vertical-align: middle;" [(ngModel)]="exportDataCriteria.includeGpsInfo" [ngModelOptions]="{standalone: true}"
                  [checked]="exportDataCriteria.includeGpsInfo" [disabled]="exportDataCriteria.saveAs != 'JSON' || exportDataCriteria.interpolateData" style="margin-top: 5px;" />
          <label>Include GPS Info</label>
        </div>

        <hr>
        <div>
          <button type="button" class="btn btn-info" (click)="exportDataWithOptions()" style="float: right; margin-right: 1px; margin-bottom: 0px; margin-top: 3px; margin-bottom: 15px;">Export</button>
        </div>

      </div>
  </div>
</ng-template>
